// AD-2 · Reflect On The Move — locked copy mirror (r2).
// Frontend mirror of backend/domain/ad2_reflection_registry.py.
// A doctrine test asserts key/wording equality. Do not edit
// without a paired backend change.

export const AD2_REGISTRY_VERSION      = "ad2.v1";
export const AD2_ORCHESTRATION_VERSION = "ad2_v1.0";

// Amendment 2 — hard 90-second ceiling.
export const AD2_MAX_DURATION_SECONDS = 90;

// Amendment 4 — locked safety copy (verbatim).
export const AD2_SAFETY_COPY =
  "Only start this reflection when it is safe and lawful to do so. " +
  "Do not hold or operate your phone while driving. Once recording " +
  "begins, no further interaction is required.";

// Amendment 4 — locked button labels.
export const AD2_START_BUTTON_LABEL = "Start 90-second reflection";
export const AD2_NOT_NOW_BUTTON_LABEL = "Not now";
export const AD2_STOP_BUTTON_LABEL = "Stop reflection";

// Amendment 8 — two-route post-capture consent labels.
export const AD2_SAVE_BUTTON_LABEL = "Save reflection";
export const AD2_DISCARD_BUTTON_LABEL = "Discard reflection";

// Amendment 3 — the single, non-adaptive prompt.
export const AD2_REFLECTION_PROMPT =
  "What is the one thing from today's lesson that you want to remember?";
